module.exports = __webpack_public_path__ + "img/master.57c49a76.png";